export const navlinks = {
  dashboard: 'Dashboard',
  forecast: 'Forecasting',
  profile: 'GCSP Forecasting',
  gcspDashboard: 'GCSP Dashboard',
};
